import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import image from "../assets/itil.jpeg"
import RatingStars from "../components/common/RatingStars";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineGlobeAlt } from "react-icons/hi";
import CourseDetailsCardITIL from "../components/core/Course/CourseDetailsCardITIL";
import ReactMarkdown from "react-markdown";
import { BsFillCaretRightFill, BsFillCaretRightSquareFill } from "react-icons/bs";
import CourseAccordionBar from "../components/core/Course/CourseAccordionBar"
import Footer from "../components/common/Footer";

const CourseDetails = () => {
  const [isActive, setIsActive] = useState(Array(0));
  const handleActive = () => {
    // console.log("called", id)
    setIsActive(

    );
  };

  return (
    <>
      <div className={`relative w-full bg-richblue-5`}>
        <div className="mx-auto box-content px-4 lg:w-[1260px] 2xl:relative ">
          <div className="mx-auto grid min-h-[450px] max-w-maxContentTab justify-items-center py-8 lg:mx-0 lg:justify-items-start lg:py-0 xl:max-w-[810px]">
            <div className="relative block max-h-[30rem] lg:hidden">
              <div className="absolute bottom-0 left-0 h-full w-full shadow-[#161D29_0px_-64px_36px_-28px_inset]"></div>
              <img
                src={image}
                alt="course thumbnail"
                className="aspect-auto w-full"
              />
            </div>

            <div
              className={`z-30 my-5 flex flex-col justify-center gap-4 py-5 text-lg text-richblue-700`}
            >
              <div>
                <p className="text-4xl font-bold text-richblue-700 sm:text-[42px]">
                ITIL® 4 Foundation Certification Training Course
                </p>
              </div>

              <p className={`text-richblue-500`}>
              With the growing emphasis on delivering high-quality IT services and aligning them with business objectives, ITIL® 4 has emerged as a globally recognized framework for effective IT Service Management (ITSM).
              By mastering ITIL® 4 concepts, participants will gain the skills to optimize IT service delivery, improve customer satisfaction, and drive business value. 
              </p>
              <div className="text-md flex flex-wrap items-center gap-2">
                <span className="text-yellow-25">5</span>
                <RatingStars Review_Count={5} Star_Size={20} />
                <span>{`(${5} reviews)`}</span>
                <span> | </span>
                <span>{`${200}+ Professionals Enrolled`}</span>
              </div>

              <div className="flex flex-wrap gap-5 text-lg">
                <p className="flex items-center gap-2">
                  {" "}
                  <BiInfoCircle /> Created at February 15, 2024 | 8:01 PM
                </p>
                <p className="flex items-center gap-2">
                  {" "}
                  <HiOutlineGlobeAlt /> English
                </p>
              </div>
            </div>
            <div className="flex w-full flex-col gap-4 border-y border-y-richblue-300 py-4 lg:hidden">
              <p className="space-x-3 pb-4 text-3xl font-semibold text-richblue-700">
                Rs. {19999}
              </p>
              <button className="yellowButton">Enroll Now</button>
              <button className="blackButton">Request Free Demo</button>
            </div>
          </div>
          {/* Courses Card */}
          <div className="right-[2rem] top-[60px] mx-auto hidden min-h-[600px] w-1/3 max-w-[410px] translate-y-24 md:translate-y-0 lg:absolute  lg:block">
            <CourseDetailsCardITIL />
          </div>
        </div>
      </div>
      <div className="mx-auto box-content px-4 text-start text-richblue-700 lg:w-[1260px]">
        <div className="mx-auto max-w-maxContentTab lg:mx-0 xl:max-w-[810px]">
          {/* What will you learn section */}
          <div className="my-8 border border-richblue-300 p-8">
            <p className="text-3xl font-semibold">Course Overview</p>
            <div className="mt-5">
              <ReactMarkdown>
                {
                  "In today’s rapidly evolving business landscape, organizations are increasingly reliant on IT services to drive innovation, enhance customer experiences, and maintain competitive advantage. The growing complexity of IT systems and the need for seamless service delivery have made it essential for teams to adopt proven frameworks that align IT services with business goals."
                  }
              </ReactMarkdown>
              <ReactMarkdown>
                {
                  "The ITIL® 4 Foundation Certification Training Course is designed to address these challenges by providing professionals with a comprehensive understanding of the ITIL® 4 framework, its principles, and its practices. This course equips participants with the knowledge to optimize IT service management, improve operational efficiency, and deliver value to customers."
                }
              </ReactMarkdown>
            </div>
            <p className="text-3xl font-semibold mt-5">What you'll learn</p>
            <div className="flex flex-col gap-3 mt-5">
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Understand and implement the core principles and concepts of ITIL® 4.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Utilize the ITIL® 4 service value system (SVS) to deliver business value.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Integrate ITIL® 4 practices into existing organizational processes for seamless adoption.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Enhance operational efficiency through effective service management practices.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                Reduce costs while improving service quality and customer satisfaction.
                </span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>Manage and optimize IT services to support business objectives.</span>
              </p>
              <p className={`flex gap-2 items-center`}>
                <BsFillCaretRightFill />
                <span>
                   Drive continuous improvement and innovation within IT service management.
                </span>
              </p>
            </div>
          </div>

          {/* Course Content Section */}
          <div className="max-w-[830px] ">
            <div className="flex flex-col gap-3">
              <p className="text-[28px] font-semibold">Course Curriculum</p>
              <div className="flex flex-wrap justify-between gap-2">
                <div className="flex gap-2">
                  <span>
                    {8} {`module(s)`} &nbsp; |
                  </span>
                  <span>
                    {27} {`lecture(s)`} &nbsp; |
                  </span>
                  <span>{"1h 10m"} total length</span>
                </div>
                <div>
                  <button
                    className="text-yellow-25"
                    onClick={() => setIsActive([])}
                  >
                    Collapse all sections
                  </button>
                </div>
              </div>
            </div>

            {/* Course Details Accordion */}
            <div className="py-4 ">
              <CourseAccordionBar
                courseName={"Module 1: Key Concepts of Service Management"}
                courseList={[
                "Understand the key concepts of service management",
                "Recall the definitions of: Service, Utility, Warranty, Customer, User, Service Management, Sponsor",
                "Key concepts of creating value with services: Cost, Value, Organization, Outcome, Output, Risk, Utility/Warranty",
                "Key concepts of service relationships: Service Offering, Service Relationship Management, Service Provision, Service Consumption",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 2: ITIL Guiding Principles"}
                courseList={[
                "Understand how the ITIL guiding principles help organizations adopt and adapt service management",
                "Describe the nature, use, and interaction of the guiding principles",
                "Explain the use of the guiding principles: Focus on Value, Start Where You Are, Progress Iteratively with Feedback, Collaborate and Promote Visibility, Think and Work Holistically, Keep It Simple and Practical, Optimize and Automate",
                ]}                
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 3: Four Dimensions of Service Management"}
                courseList={[
                "Understand the four dimensions of service management",
                "Describe the four dimensions: Organizations and People, Information and Technology, Partners and Suppliers, Value Streams and Processes",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />{" "}
              <CourseAccordionBar
                courseName={"Module 4: ITIL Service Value System (SVS)"}
                courseList={[
                "Understand the purpose and components of the ITIL service value system",
                "Describe the ITIL service value system",
                "Understand the activities of the service value chain and how they interconnect",
                "Describe the interconnected nature of the service value chain and how it supports value streams",
               ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 5: ITIL Practices Overview"}
                courseList={[
                "Know the purpose and key terms of 18 ITIL practices",
                "Recall the purpose of ITIL practices",
                "Recall definitions of ITIL terms: Availability, IT Asset, Event, Configuration Item, Change, Incident, Problem, Known Error",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 6: Detailed ITIL Practices"}
                courseList={[
                "Understand 7 ITIL practices in detail",
                "Explain how these practices fit within the service value chain",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 7: ITIL Best Practices and Concepts"}
                courseList={[
                "Concept of ITIL best practices in the public domain",
                "Why ITIL® is so successful?",
                "Concept of a service",
                "Concept of internal and external customers",
                "Concept of internal and external services",
                "Concept of service management",
                "Concept of IT service management",
                "Concept of stakeholders in service management",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
              <CourseAccordionBar
                courseName={"Module 8: ITIL Processes, Functions, and Frameworks"}
                courseList={[
                "Processes and functions of ITIL v4",
                "The Four Dimensions of Service Management",
                "The Eight Guiding Principles",
                "The Six Service Value Chain Activities",
                "ITIL Management Practices: Introduction",
                "General Management Practices",
                ]}
                isActive={isActive}
                handleActive={handleActive}
              />
            </div>


          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CourseDetails;
